/** Insert-variable row: the five people actually use, rest behind a toggle. */
export const PINNED_INSERT_VAR_KEYS = [
  '{{business_name}}',
  '{{lead_firstname}}',
  '{{lead_lastname}}',
  '{{footer_text}}',
  '{{user_name}}',
];

export function partitionInsertVariables(keywords, pinnedKeys = PINNED_INSERT_VAR_KEYS) {
  const pinSet = new Set(pinnedKeys);
  const byKey = new Map(keywords.map(kw => [kw.key, kw]));
  return {
    pinned: pinnedKeys.map(key => byKey.get(key)).filter(Boolean),
    extra: keywords.filter(kw => !pinSet.has(kw.key)),
  };
}
